import React from 'react';
import { Icon } from '@iconify/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';
import reactjsIcon from '@iconify/icons-logos/react';
import { HighlightedTextIcon } from 'components/molecules';

const Text = () => (
  <>
    I’ve spent about two years on improving my skills in{' '}
    <span className="font-bold text-gray-800">website development</span> using{' '}
    <HighlightedTextIcon
      as="a"
      href="https://reactjs.org"
      className="mx-2"
      icon={<Icon icon={reactjsIcon} />}
    >
      ReactJS
    </HighlightedTextIcon>{' '}
    and{' '}
    <HighlightedTextIcon className="mx-2" icon={<Icon icon={tailwindcssIcon} />}>
      TailwindCSS
    </HighlightedTextIcon>{' '}
    that I’m now pretty confident in building apps using these tools:
  </>
);

const skills = {
  text: <Text />,
};

export default skills;
